// The ids a user's look is built from, shared so the server schema, the web app's pickers and the
// boot script (apps/web/public/theme-boot.js, checked by a test) all accept exactly the same values.
// A palette or theme id the schema doesn't know turns a whole preferences save into a 400, so add new
// ones here first.
/** colour profiles: the chrome, accent and tint every neutral is mixed from (tokens.css [data-palette]). */
export const PALETTE_IDS = [
    'indigo', 'blue', 'red', 'green', 'gold', 'silver',
    'teal', 'slate', 'graphite', 'burgundy', 'forest',
    'plum', 'teak', 'olive', 'sand',
];
/** whole-app themes: frame, type, corners and depth (tokens.css [data-ui-theme]). 'evolved' is the default. */
export const UI_THEME_IDS = ['evolved', 'contrast', 'stegi'];
//# sourceMappingURL=prefs.js.map